module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figF03_high-pass-filtered-composite-deviations.7163d54d.png";